import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationPedido } from '../integration-pedido';

@Injectable({
    providedIn: 'root'
})
export class IntegrationPedidoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/pedido`;
    }

    /** Executa as integrações de leitura dos pedidos com os sistemas ERP's manualmente */
    execReadIntegrationManual(entity: IntegrationPedido): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(`${this.pathApi}/manual`, null, {params, responseType: 'text'});
    }

    /** Executa a integração de leitura individual dos dados do pedido informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
